import { HardTokenIntegrationController } from '../hard-token-integration.controller';

export class Controller extends HardTokenIntegrationController {

    /** @ngInject */
    constructor(HardTokenService) {
        super(HardTokenService);
    }

    $onInit() {
        super.$onInit();
        this.type = 'YUBIKey_USB_KEY';
        this.otpType = 'U2F';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/integrate-fido-u2f/integrate-fido-u2f.controller.js